<template>
  <div :class="jel_getClassObject(content)">
    <!-- tag="div" nécessaire pour accessibilité, éviter div dans un span -->
    <ValidationProvider
      v-slot="validationContext"
      :name="content.libCodePostal"
      :rules="`required|compteValidation:codePostal`"
      mode="aggressive"
      tag="div"
    >
      <b-form-group :label="content.libCodePostal" label-for="codePostal">
        <b-form-input
          :id="content.idHTML ? content.idHTML : 'codePostal'"
          v-model="codePostal"
          :maxlength="$t('compte.codePostal.mask').length"
          autocomplete="postal-code"
          :state="getValidationState(validationContext)"
          :disabled="disabled"
          @keydown.enter="getValidationState(validationContext)"
          @keyup.native="maskCodePostal($event)"
        ></b-form-input>
        <ErreurValidation
          id="codePostal-live-feedback"
          :message="validationContext.errors[0]"
        ></ErreurValidation>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import ErreurValidation from '@/components/formulaire/compte/ErreurValidation';

export default {
  name: 'FormulaireCodePostal',

  components: { ErreurValidation },
  props: {
    content: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    codePostal: {
      get() {
        return this.$store.state.compte.adresse.codePostal;
      },
      set(value) {
        this.$store.commit('compte/SET_CODE_POSTAL', value);
      },
    },
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      // Uniquement si la validation a été effectuée une fois et que le champ est invalide
      this.validated = validated;
      if (validated && !valid) {
        return valid;
      }
      return null;
    },

    // Passe-passe permettant de correcterment positionner le curseur sur delete/backspace
    // TODO: Un seul cas qui n'est pas traiter: backspace pour passer d'un bloc à l'autre (idem Telephone)
    maskCodePostal(e) {
      // Inspiration: https://github.com/vuejs-tips/vue-the-mask/issues/56
      let caretPosition = e.target.selectionStart;
      // Match the masked characters using "/"
      const lastAmountOfSpaces = (e.target.value.match(/[\s//]/g) || []).length;
      const regEx = /(\w{0,1}\d{0,1}\w{0,1})(\d{0,1}\w{0,1}\d{0,1})/;
      const replacedInput = e.target.value.replace(/\W/g, '').match(regEx);
      const formattedValue = !replacedInput[2]
        ? replacedInput[1]
        : `${replacedInput[1]} ${replacedInput[2]}`;
      this.codePostal = formattedValue.toUpperCase();

      if (formattedValue === e.target.value) {
        return;
      }
      // Match the masked characters using " "
      const newAmountOfSpaces = (formattedValue.match(/[\s]/g) || []).length;
      caretPosition += newAmountOfSpaces - lastAmountOfSpaces;

      this.$nextTick(function () {
        e.target.setSelectionRange(caretPosition, caretPosition);
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
